import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { ReactComponent as TextIcon } from "../../../../../assets/MainPage/addBlock/countDown/text.svg";
import { ReactComponent as TextIconDark } from "../../../../../assets/MainPage/addBlock/countDown/text-dark.svg";
import DatePicker from "../../../../../utils/datePicker/DatePicker";
import TimePicker from "../../../../../utils/scrollAbleTimePIcker/TimePicker";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  updatingCountDown,
  resetCountDownCard,
} from "../../../../../redux/slices/cards/cardSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";

import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";

import useFetchBlock from "../../../../../hooks/useFetchBlock";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";

import SpinnerGiff from "../../../../../assets/spinner.svg";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";
import { I18nextProvider } from "react-i18next";

const EditCountdown = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate, allLangs, tComponent, handleLanguageChange } =
    useLocales();
  const { themeDirection } = useSettings();
  const baseUrl = process.env.REACT_APP_API_URL;
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { optionId } = useParams();

  const digitColorColrDropDownRef = useRef();
  const digitColorDropDownBtnRef = useRef();
  const countBgColorDropDownRef = useRef();
  const countBgColorDropDownBtnRef = useRef();
  const [color, setColor] = useColor("#FFF");
  useEffect(() => {
    setDigitsColorHandler(color);
  }, [color]);

  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  const [bgColor, setBgColor] = useColor("#00000066");
  useEffect(() => {
    setCountDownBgColorHandler(bgColor);
  }, [bgColor]);
  const [colorCountDownBg, setColorCountDownBg] = useState("#00000066");
  const [openCountDownBgColopicker, setOpenCountDownBgColopicker] =
    useState(false);
  const setCountDownBgColorHandler = (color) => {
    setColorCountDownBg(color.hex);
  };
  const [colorCountDownDigits, setColorCountDownDigits] = useState("#FFF");
  const [openDigitsColopicker, setOpenDigitsColopicker] = useState(false);

  const setDigitsColorHandler = (color) => {
    setColorCountDownDigits(color.hex);
  };

  const handleTimeChange = (time) => {
    setSelectedTime(time);
  };
  const handleChange = (date) => {
    setSelectedDate(date);
  };
  const { setActiveMainPageNav } = useStateContext();

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [prevData, setPrevData] = useState(null);
  const url = baseUrl + "/api/user/getOption/" + userId + "/" + optionId;

  const { data, loading, error } = useFetchBlock(url);

  useEffect(() => {
    setPrevData({
      ...data?.data,
      coloum_value:
        data?.data?.coloum_value && JSON.parse(data?.data?.coloum_value),
    });
    if (error) {
      toast.error("Something went wrong...");
    }
  }, [data, error]);

  useEffect(() => {
    // console.log(prevData, "prevData");
    if (prevData?.coloum_value) {
      setValue(
        "description",
        prevData?.coloum_value?.coloum_value?.description
      );
      handleChange(new Date(prevData?.coloum_value?.coloum_value?.date));
      // (prevData?.coloum_value?.coloum_value?.time);
      setColorCountDownDigits(
        prevData?.coloum_value?.coloum_value?.digitColor || "#fff"
      );
      setColor((color) => {
        return {
          ...color,
          hex: prevData?.coloum_value?.coloum_value?.digitColor || "#fff",
        };
      });
      setColorCountDownBg(
        prevData?.coloum_value?.coloum_value?.digitBgColor || "#00000066"
      );
      setBgColor((color) => {
        return {
          ...color,
          hex:
            prevData?.coloum_value?.coloum_value?.digitBgColor || "#00000066",
        };
      });

      if (prevData?.language) {
        setSelectedLang(prevData?.language);
        const matchedLang = allLangs?.find(
          (lang) => lang.value === prevData?.language
        );
        const shouldSetLang = matchedLang?.label;
        setSelectedReporterType(shouldSetLang);
        handleLanguageChange(prevData?.language);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prevData]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  // Digits color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openDigitsColopicker &&
        digitColorColrDropDownRef.current &&
        !digitColorColrDropDownRef.current.contains(e.target) &&
        !digitColorDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenDigitsColopicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openDigitsColopicker]);

  // Bg color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openCountDownBgColopicker &&
        countBgColorDropDownRef.current &&
        !countBgColorDropDownRef.current.contains(e.target) &&
        !countBgColorDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenCountDownBgColopicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [openCountDownBgColopicker]);

  // data needed for calling fetching list
  const usertoken = user.token;
  const linkId = localStorage.getItem("linkId");
  const linkListData = {
    userId,
    usertoken,
    linkId,
  };
  const [subLoader, setSubLoader] = useState(false);

  const submitHandler = async (data) => {
    if (!selectedDate) {
      toast.error("Please select a Date");
      return;
    } else if (!selectedTime) {
      toast.error("Please select Time");
      return;
    } else {
      const newData = {
        coloum_type: "countdown",
        coloum_name: "countdown",
        language: selectedLang,
        coloum_value: {
          description: data.description,
          date: selectedDate,
          time: selectedTime,
          digitColor: colorCountDownDigits,
          digitBgColor: colorCountDownBg,
        },
        optionId: optionId,
      };
      setSubLoader(true);
      await dispatch(updatingCountDown(newData));
      await fetchingLinksList(); // fetching link list after submiting , so list become refresh
      setSubLoader(false);
    }
  };

  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };

  const {
    updatedCountDownCardError,
    updatedCountDownCardSuccess,
    updatedCountDownCardLoading,
  } = useSelector((state) => state?.cards?.countDownCard);
  const { status, message } = useSelector(
    (state) => state?.cards?.countDownCard?.updatedCountDownCard
  );

  useEffect(() => {
    if (status === "success" && updatedCountDownCardSuccess) {
      toast.success(message);
      navigate("/dashboard");
    }
    if (status === "failed" && updatedCountDownCardSuccess) {
      toast.error(message);
    }
    dispatch(resetCountDownCard());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    updatedCountDownCardError,
    updatedCountDownCardSuccess,
    dispatch,
    updatedCountDownCardLoading,
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const deleteHandler = async () => {
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    await dispatch(deleteBlock(obj)).then(() => {});
  };

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  //  delete block api response state handler
  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
    isDeleteBlockErrorMsg,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      toast.error(isDeleteBlockErrorMsg);
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={selectedLang}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark">
              {" "}
              {translate("countdown")}{" "}
            </p>
          </div>
        </Link>
      </div>
      <I18nextProvider i18n={i18nForComponent}>
        <div
          className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-[10px] bg-light_bg_v5 p-[25px] dark:bg-dark-secondary dark:border-color_dark">
            <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark">
                {tComponent("addcountdown.edit_countdown")}
              </p>
              <div
                className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
              >
                {selectedReporterType ? selectedReporterType : "English"}
              </div>
            </div>
            <form onSubmit={handleSubmit(submitHandler)}>
              <div className="relative">
                <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                {darkMode ? <TextIconDark /> : <TextIcon />}
                </div>
                <input
                  type="text"
                  id="heading"
                  {...register("description", {
                    required: "Description required",
                  })}
                  className={`dark:bg-dark-secondary rounded-lg border bg-light_bg_v5 dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color focus:placeholder:dark:text-color_v1_dark block w-full ${
                    errors?.description
                      ? "border-state_color_error dark:bg-dark-secondary"
                      : "focus:border-font_light_color border-light_bg_v2 dark:border-color_dark focus:dark:border-font_color"
                  }`}
                  placeholder={tComponent(
                    "addcountdown.enter_countdown_description"
                  )}
                />
              </div>
              {errors?.description && (
                <small className="text-state_color_error text-small3">
                  {errors?.description?.message}
                </small>
              )}
              <div className="flex sm:flex-row md:flex-col xl:flex-row flex-col justify-between gap-[5px] sm:gap-5 sm:mt-[10px] mt-[5px] ">
                <div className="w-full">
                  <DatePicker
                    value={selectedDate}
                    onChange={handleChange}
                    placeholder={tComponent("addcountdown.choose_date")}
                    className=""
                  />
                </div>
                <div className="w-full rounded-lg">
                  <TimePicker
                    handleTimeChange={handleTimeChange}
                    prevData={prevData?.coloum_value?.coloum_value?.time}
                  />
                </div>
              </div>
              <div className="flex mt-[13px] md:mt-5 gap-5 items-center flex-col xl:flex-row">
                <div className="relative flex items-center justify-start w-full ">
                  <div
                    ref={digitColorDropDownBtnRef}
                    onClick={() =>
                      setOpenDigitsColopicker(!openDigitsColopicker)
                    }
                    style={{
                      background: colorCountDownDigits,
                    }}
                    className={`rounded-md me-[16px] border lg:me-[19px] cursor-pointer min-w-[48px] w-[48px] min-h-[48px] h-[48px] lg:min-w-[48px] lg:w-[48px] lg:min-h-[48px] lg:h-[48px] relative`}
                  ></div>
                  {openDigitsColopicker && (
                    <div
                      className="absolute top-0 w-full pb-5 "
                      style={{ zIndex: "999999999" }}
                    >
                      <div
                        ref={digitColorColrDropDownRef}
                        className="border bg-white shadow-xl rounded-lg p-3"
                      >
                        <ColorPicker
                          color={color}
                          onChange={setColor}
                          hideInput={true}
                          height={150}
                        />
                        <div className="flex flex-wrap 2xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                          <div className="flex justify-center items-center gap-1 w-full">
                            <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                              <p>HEX</p>
                            </div>
                            <p>:</p>
                            <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                              <p>{color.hex}</p>
                            </div>
                          </div>
                          <div className="flex gap-1 justify-between w-full ">
                            <div className="border rounded-md px-1 py-0.5 text-small1">
                              {Math.round((color.rgb.a / 1) * 100)}%
                            </div>
                            <button
                              className="rounded-full px-3 text-small2_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                              onClick={() => setOpenDigitsColopicker(false)}
                            >
                              DONE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    <div className="text-small3 md:text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
                      {tComponent("addcountdown.timer_digit_color")}
                    </div>
                    <div className="text-small2_b text-heading_color dark:text-color_v1_dark">
                      <input
                        value={colorCountDownDigits}
                        type="text"
                        className="focus:outline-none bg-transparent -mt-[8px]"
                        onChange={(e) => {
                          setColor((color) => {
                            return { ...color, hex: e.target.value };
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="relative flex items-center justify-start w-full ">
                  <div
                    ref={countBgColorDropDownBtnRef}
                    onClick={() =>
                      setOpenCountDownBgColopicker(!openCountDownBgColopicker)
                    }
                    style={{
                      background: colorCountDownBg,
                    }}
                    className={`rounded-md me-[16px] lg:me-[19px] border cursor-pointer min-w-[48px] w-[48px] min-h-[48px] h-[48px] lg:min-w-[48px] lg:w-[48px] lg:min-h-[48px] lg:h-[48px] relative`}
                  ></div>
                  {openCountDownBgColopicker && (
                    <div
                      className="absolute top-0 w-full pb-5 "
                      style={{ zIndex: "999999999" }}
                    >
                      <div
                        ref={countBgColorDropDownRef}
                        className="border bg-white shadow-xl rounded-lg p-3"
                      >
                        <ColorPicker
                          color={bgColor}
                          onChange={setBgColor}
                          hideInput={true}
                          height={150}
                        />
                        <div className="flex flex-wrap 2xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                          <div className="flex justify-center items-center gap-1 w-full">
                            <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                              <p>HEX</p>
                            </div>
                            <p>:</p>
                            <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                              <p>{color.hex}</p>
                            </div>
                          </div>
                          <div className="flex gap-1 justify-between w-full ">
                            <div className="border rounded-md px-1 py-0.5 text-small1">
                              {Math.round((color.rgb.a / 1) * 100)}%
                            </div>
                            <button
                              className="rounded-full px-3 text-small2_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                              onClick={() =>
                                setOpenCountDownBgColopicker(false)
                              }
                            >
                              DONE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    <div className="text-small3 md:text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
                      {tComponent("addcountdown.timer_background_color")}
                    </div>
                    <div className="text-small2_b text-heading_color dark:text-color_v1_dark">
                      <input
                        value={colorCountDownBg}
                        type="text"
                        className="focus:outline-none bg-transparent -mt-[8px]"
                        onChange={(e) => {
                          setBgColor((color) => {
                            return { ...color, hex: e.target.value };
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex mt-[26px] items-center justify-end">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(true)}
                  className="flex justify-center items-center"
                >
                  {darkMode ? <TrashIconDark /> : <TrashIcon />}
                  <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                    {tComponent("addcountdown.delete_cap")}
                  </p>
                </button>

                <ExtraSmallFilledButton
                  buttonType={"submit"}
                  name={tComponent("addcountdown.save_cap")}
                  isLoading={subLoader}
                  classes={"ms-3"}
                />
              </div>
            </form>
          </div>
        </div>
      </I18nextProvider>
    </>
  );
};

export default EditCountdown;
